import React, { useEffect } from "react";

/**
 * Centered modal dialog (assets, leave...).
 * Closes on Escape / backdrop click unless `busy`.
 */
const Dialog = ({
  title,
  subtitle,
  onClose,
  busy,
  footer,
  children,
  size = "md",
}) => {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && !busy && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [busy, onClose]);

  return (
    <div
      className="modal-overlay modal-overlay--dark"
      onClick={() => !busy && onClose()}
    >
      <div
        className={`app-dialog app-dialog--${size}`}
        role="dialog"
        aria-modal="true"
        aria-labelledby="app-dialog-title"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="app-dialog-header">
          <div>
            <h5 id="app-dialog-title" className="fw-bold text-navy m-0">
              {title}
            </h5>
            {subtitle && (
              <div className="text-slate-500 fs-080 mt-1">{subtitle}</div>
            )}
          </div>
          <button
            type="button"
            className="btn-close"
            aria-label="Close"
            onClick={onClose}
            disabled={busy}
          ></button>
        </div>
        <div className="app-dialog-body">{children}</div>
        {footer && <div className="app-dialog-footer">{footer}</div>}
      </div>
    </div>
  );
};

export default Dialog;
